import { IconButton } from '@app/components/core/button/IconButton'
import Row from '@app/components/layout/Row'
import { faSliders } from '@fortawesome/pro-regular-svg-icons'
import { SearchField, SearchFieldProps } from './SearchField'
import useMediaQuery from '@app/util/useMediaQuery'
import { useState } from 'react'
import useTransform from '@app/util/useTransform'
import { Tooltip } from '@app/components/core/tooltip/Tooltip'
import { useLanguage } from '@i18n/useLanguage'
import { i18n } from '@i18n/index'

export type SearchBarProps = Omit<
  SearchFieldProps,
  'isFocused' | 'setIsFocused'
> & {
  currentView: 'grid' | 'map'
  onSwitchView?: () => void
  onFiltersOpen?: () => void
  activeFilterCount?: number
}

export const SearchBar = (props: SearchBarProps) => {
  const isMobile = useMediaQuery()
  const [language] = useLanguage()
  const translations = i18n.languages[language].app.common
  const [isFocused, setIsFocused] = useState(false)
  const transformStyle = useTransform('center')
  const searchFocus = isMobile && isFocused

  return (
    <Row
      gap={isMobile ? '1rem' : '2rem'}
      style={{
        alignItems: 'center',
        width: '100%',
        zIndex: 5,
        userSelect: 'none',
        ...transformStyle,
      }}
    >
      <SearchField
        isFocused={isFocused}
        setIsFocused={setIsFocused}
        suggestionsFetcher={props.suggestionsFetcher}
        hideClearButton
        {...props}
      />
      {/* TODO: no map for now */}
      {!searchFocus && (
        <Row gap={isMobile ? '0.5rem' : '1rem'}>
          {/* {props.onSwitchView && !isMobile && (
            <IconButton
              variant="secondary"
              icon={props.currentView === 'grid' ? faMap : faGridRound}
              onClick={props.onSwitchView}
            />
          )} */}
          {props.onFiltersOpen && (
            <Tooltip content={translations.filtersTooltip}>
              <IconButton
                variant="secondary"
                icon={faSliders}
                onClick={props.onFiltersOpen}
                notification={props.activeFilterCount}
              />
            </Tooltip>
          )}
        </Row>
      )}
    </Row>
  )
}
